import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '../../services/modal.service';

@Injectable()
export class ListActionsService {

    constructor(private http: HttpClient, private modal: ModalService) { }

    public listActionUpdate(endpoint: string, idList: string[], isPost: boolean, additionParams?: any): Promise<any> {
        let params = { idList: idList };
        if (additionParams) {
            Object.assign(params, additionParams);
        }
        if (isPost) {
            return this.http.post(endpoint, params).toPromise().catch((err) => {
                if (err.error) {
                    // will be array
                    this.modal.error({ message: err.error[0].errorMessage })
                } else {
                    this.modal.error({ message: 'Cannot post endpoint' });
                }
                return Promise.reject(err);
            });
        } else {
            return this.http.get(endpoint, { params: params }).toPromise().catch((err) => {
                if (err.error) {
                    // will be array
                    this.modal.error({ message: err.error[0].errorMessage })
                } else {
                    this.modal.error({ message: 'Cannot get endpoint' });
                }
                return Promise.reject(err);
            });
        }
    }

    public duplicate(plannerId, advertiserId, marketId): void {
        let url = "#/planner/edit/" + plannerId + "/copy?advertiserId=" + advertiserId + "&marketId=" + marketId;
        window.open(url, '_blank');
    }

    public getOptionsFromEnum(enumObject: any): any[] {
        let isNumberEnum = false;
        let options = [];
        for (const key in enumObject) {
            if (!isNaN(Number(key))) {
                isNumberEnum = true;
                options.push({ label: enumObject[key], name: Number(key) });
            }
        }
        if (!isNumberEnum) {
            for (const key of Object.keys(enumObject)) {
                options.push({ label: key, name: enumObject[key] });
            }
        }
        return options;
    }

    // if labelField is undefined, use key instead
    public getOptionsFromConst(constObject: any, idField: string, labelField?: string): any[] {
        let options = [];
        for (const key in constObject) {
            options.push({ label: labelField ? constObject[key][labelField] : key, name: constObject[key][idField] });
        }
        return options;
    }
}
